import { render, staticRenderFns } from "./UtilButton.vue?vue&type=template&id=8ebd886a&scoped=true&"
import script from "./UtilButton.vue?vue&type=script&lang=js&"
export * from "./UtilButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebd886a",
  null
  
)

export default component.exports